module.exports = __webpack_public_path__ + "img/zhwl1.1b66d54c.png";